// templates - Template configurations matching backend
// Implements FR-TMP-002: MVP template definitions

import { Template } from '../types/card';

export const TEMPLATES: Record<string, Template> = {
  start_stop_continue: {
    id: 'start_stop_continue',
    name: 'Start/Stop/Continue',
    gridTemplate: '1fr 1fr 1fr 300px',
    votingEnabled: true,
    defaultDotsPerUser: 3,
    columns: [
      {
        key: 'start',
        label: 'Anfangen',
        description: 'Was sollten wir anfangen?',
        color: 'var(--tertiary-pastel)',
        borderColor: 'var(--color-green)',
        icon: '▶️',
        width: '1fr',
      },
      {
        key: 'stop',
        label: 'Aufhören',
        description: 'Was sollten wir aufhören?',
        color: 'var(--secondary-pastel)',
        borderColor: 'var(--color-red)',
        icon: '⏹️',
        width: '1fr',
      },
      {
        key: 'continue',
        label: 'Weitermachen',
        description: 'Was sollten wir weitermachen?',
        color: 'var(--primary-pastel)',
        borderColor: 'var(--color-blue)',
        icon: '➡️',
        width: '1fr',
      },
      {
        key: 'actions',
        label: 'Action Items',
        description: 'Konkrete nächste Schritte',
        color: 'var(--purple-pastel)',
        borderColor: 'var(--color-purple)',
        icon: '✓',
        width: '300px',
      },
    ],
  },

  '4ls': {
    id: '4ls',
    name: '4Ls',
    gridTemplate: '1fr 1fr 1fr 1fr 300px',
    votingEnabled: true,
    defaultDotsPerUser: 5,
    columns: [
      {
        key: 'liked',
        label: 'Gemocht',
        description: 'Was hat uns gefallen?',
        color: 'var(--tertiary-pastel)',
        borderColor: 'var(--color-green)',
        icon: '❤️',
        width: '1fr',
      },
      {
        key: 'learned',
        label: 'Gelernt',
        description: 'Was haben wir gelernt?',
        color: 'var(--primary-pastel)',
        borderColor: 'var(--color-blue)',
        icon: '💡',
        width: '1fr',
      },
      {
        key: 'lacked',
        label: 'Gefehlt',
        description: 'Was hat gefehlt?',
        color: 'var(--orange-pastel)',
        borderColor: 'var(--color-orange)',
        icon: '⚠️',
        width: '1fr',
      },
      {
        key: 'longed_for',
        label: 'Gewünscht',
        description: 'Was haben wir uns gewünscht?',
        color: 'var(--pink-pastel)',
        borderColor: 'var(--color-pink)',
        icon: '✨',
        width: '1fr',
      },
      {
        key: 'actions',
        label: 'Action Items',
        description: 'Konkrete nächste Schritte',
        color: 'var(--purple-pastel)',
        borderColor: 'var(--color-purple)',
        icon: '✓',
        width: '300px',
      },
    ],
  },

  mad_sad_glad: {
    id: 'mad_sad_glad',
    name: 'Mad/Sad/Glad',
    gridTemplate: '1fr 1fr 1fr 300px',
    votingEnabled: true,
    defaultDotsPerUser: 3,
    columns: [
      {
        key: 'mad',
        label: 'Wütend',
        description: 'Was hat uns verärgert?',
        color: 'var(--secondary-pastel)',
        borderColor: 'var(--color-red)',
        icon: '😠',
        width: '1fr',
      },
      {
        key: 'sad',
        label: 'Traurig',
        description: 'Was hat uns enttäuscht?',
        color: 'var(--orange-pastel)',
        borderColor: 'var(--color-orange)',
        icon: '😢',
        width: '1fr',
      },
      {
        key: 'glad',
        label: 'Froh',
        description: 'Was hat uns gefreut?',
        color: 'var(--tertiary-pastel)',
        borderColor: 'var(--color-green)',
        icon: '😊',
        width: '1fr',
      },
      {
        key: 'actions',
        label: 'Action Items',
        description: 'Konkrete nächste Schritte',
        color: 'var(--purple-pastel)',
        borderColor: 'var(--color-purple)',
        icon: '✓',
        width: '300px',
      },
    ],
  },

  sailboat: {
    id: 'sailboat',
    name: 'Segelboot',
    templateIcon: '⛵',
    gridTemplate: '1fr 1fr 1fr 1fr 300px',
    votingEnabled: true,
    defaultDotsPerUser: 5,
    columns: [
      {
        key: 'wind',
        label: 'Wind',
        description: 'Was hat uns vorangebracht?',
        color: 'var(--tertiary-pastel)',
        borderColor: 'var(--color-green)',
        icon: '💨',
        width: '1fr',
      },
      {
        key: 'anchor',
        label: 'Anker',
        description: 'Was hat uns gebremst?',
        color: 'var(--orange-pastel)',
        borderColor: 'var(--color-orange)',
        icon: '⚓',
        width: '1fr',
      },
      {
        key: 'rocks',
        label: 'Felsen',
        description: 'Welche Risiken liegen vor uns?',
        color: 'var(--secondary-pastel)',
        borderColor: 'var(--color-red)',
        icon: '🪨',
        width: '1fr',
      },
      {
        key: 'island',
        label: 'Insel',
        description: 'Wo wollen wir hin?',
        color: 'var(--primary-pastel)',
        borderColor: 'var(--color-blue)',
        icon: '🏝️',
        width: '1fr',
      },
      {
        key: 'actions',
        label: 'Action Items',
        description: 'Konkrete nächste Schritte',
        color: 'var(--purple-pastel)',
        borderColor: 'var(--color-purple)',
        icon: '✓',
        width: '300px',
      },
    ],
  },
};

/**
 * GET template by ID
 */
export function getTemplate(templateId: string): Template | undefined {
  return TEMPLATES[templateId];
}

/**
 * GET CSS class name for template grid
 */
export function getTemplateGridClass(templateId: string): string {
  const classMap: Record<string, string> = {
    start_stop_continue: 'startStopContinue',
    '4ls': 'fourLs',
    mad_sad_glad: 'madSadGlad',
    sailboat: 'sailboat',
  };

  return classMap[templateId] || 'startStopContinue';
}
